import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dataListContainer" }
const _hoisted_2 = { class: "leftSide" }
const _hoisted_3 = {
  key: 0,
  class: "rightSide"
}
const _hoisted_4 = {
  key: 1,
  class: "rightSide"
}
const _hoisted_5 = ["download", "href"]
const _hoisted_6 = {
  key: 2,
  class: "rightSide"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 5,
  class: "rightSide"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AttachmentList = _resolveComponent("AttachmentList")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datalist, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: item
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
        (item.value?.tableHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_DataTable, {
                class: "datatable",
                tableHeader: item.value.tableHeader,
                noDataText: item.value.noDataText,
                tableData: item.value.tableData,
                "stop-propa-on-pdf": _ctx.stopPropaOnPdf,
                onSelect: _ctx.emitSelect,
                onDownloadPdf: _ctx.emitDownload
              }, null, 8, ["tableHeader", "noDataText", "tableData", "stop-propa-on-pdf", "onSelect", "onDownloadPdf"])
            ]))
          : (item.value?.linkText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("a", {
                  download: item.value.linkText,
                  href: item.value.link,
                  class: _normalizeClass(item.value.link === '' && 'disabled'),
                  target: "_blank"
                }, _toDisplayString(item.value.linkText), 11, _hoisted_5)
              ]))
            : (item.value?.pj)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_AttachmentList, {
                    data: item.value.pjs,
                    action: item.value.action
                  }, null, 8, ["data", "action"])
                ]))
              : (item.value?.pdfExist)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "rightSide",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitDownload && _ctx.emitDownload(...args)))
                  }, [
                    _createElementVNode("img", {
                      class: "pdf-icon",
                      src: _ctx.pdfIcon,
                      alt: "pdf download-pdf"
                    }, null, 8, _hoisted_7)
                  ]))
                : (item.value?.pageGoTo)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 4,
                      class: "rightSide",
                      to: { name: item.value?.pageGoTo, params: { id: item.value.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.value.id ?? ''), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.value ?? ''), 1))
      ]))
    }), 128))
  ]))
}